import { MediationKindEnum } from "common/enums/MediationKindEnum";
import { useCallback, useEffect, useState } from "react";
import { MediationKindSelectDialogProps } from "./interfaces";

export const useMediationKindSelectDialogHooks = (
  props: MediationKindSelectDialogProps
) => {
  const [mediationKinds, setMediationKinds] = useState<
    MediationKindSelectDialogProps["mediationKinds"]
  >(props.mediationKinds);
  const [busy, setBusy] = useState(false);

  const onModeClick = useCallback((mediationKind: MediationKindEnum) => {
    setMediationKinds((prev) => {
      if (prev.includes(mediationKind)) {
        return prev.filter((v) => v !== mediationKind).slice();
      } else {
        return [...prev, mediationKind];
      }
    });
  }, []);

  const onOkClick = useCallback(() => {
    // OKボタンクリック時
    setBusy(true);
  }, []);

  useEffect(() => {
    setTimeout(() => setMediationKinds(props.mediationKinds), 0);
  }, [props.mediationKinds]);

  useEffect(() => {
    if (busy) {
      props.onOkClick(mediationKinds);
      setTimeout(() => setBusy(false), 0);
    }
  }, [busy, mediationKinds, props]);

  return { mediationKinds, busy, onModeClick, onOkClick } as const;
};
